import { useEffect, useRef } from 'react'
import { Nav } from './Nav'
import { Select } from './Select'
import { Assign } from './Assign'
import { Payment } from './Payment'
import { Confirmation } from './Confirmation'
import { Summary } from './Summary'
import { useGlobalState } from '../../hooks/useGlobalState'
import { ACTIONS } from '../../state'

const steps = [
   '1. Select Your Tickets',
   '2. Assign Your Tickets',
   '3. Payment',
   '4. Confirmation',
]

export const RegisterForm = () => {
   const { promoCode, discount, currStageIdx, dispatch, orderResponse, invalidInputMsg, cart, ticketFields, calculateTotal } = useGlobalState()
   const promo_code = (promoCode || sessionStorage.getItem('promo'))
   const modalRef = useRef(null)

   useEffect(() => {
      dispatch({ type: ACTIONS.SET, entity: 'promoCode', payload: promo_code || (discount ? "early" + discount : "") })
      dispatch({ type: ACTIONS.SET, entity: 'calculateTotal', payload: !calculateTotal })
      return () => dispatch({ type: ACTIONS.REMOVE_TICKETS })
   }, [])

   const handelClick = (diff) => {
      if (diff === 1) {
         if (currStageIdx === steps.length - 1) return
         if (currStageIdx === 1) {
            if (inputValidations()) {
               return
            }
         }
      } else if (currStageIdx === 0) return
      modalRef.current.scrollTo(0, 0)
      dispatch({ type: ACTIONS.SET, entity: 'currStageIdx', payload: currStageIdx + diff })
      dispatch({ type: ACTIONS.SET, entity: 'invalidInputMsg', payload: [] })
   }

   const inputValidations = () => {
      const msg = []
      cart.map((t, idx) => {
         ticketFields[t.type_id]?.map(field => {
            const val = t[field.internal_name]
            if (!field.validations?.required) return
            if (!val) {
               msg.push({ ticket: idx + 1, field: field.internal_name, msg: `invalid ${field.label}` })
               return
            }
            if (field.validations?.min) {
               if (val?.length < field.validations.min) {
                  msg.push({ ticket: idx + 1, field: field.internal_name, msg: `invalid ${field.label}` })
                  return
               }
            }
            if (field.validations?.max) {
               if (val?.length > field.validations.max) {
                  msg.push({ ticket: idx + 1, field: field.internal_name, msg: `invalid ${field.label}` })
                  return
               }
            }
            if (field.validations?.pattern) {
               const pattern = new RegExp(field.validations.pattern)
               if (!pattern.test(val)) {
                  msg.push({ ticket: idx + 1, field: field.internal_name, msg: `invalid ${field.label}` })
                  return
               }
            }
            if (field.validations?.unique) {
               if (cart.filter(x => x[field.internal_name] === val).length > 1) {
                  msg.push({ ticket: idx + 1, field: field.internal_name, msg: `${field.label} must be unique` })
                  return
               }
            }
         })
      })
      dispatch({ type: ACTIONS.SET, entity: 'invalidInputMsg', payload: msg })
      return msg.length
   }

   const closeModal = () => {
      dispatch({ type: ACTIONS.RESET_CART })
      dispatch({ type: ACTIONS.SET_MODAL_STATUS, payload: { modal: 'registerForm', status: false } })
   }

   return (
      <div className="modal" ref={modalRef}>
         <div className='register-form'>
            <header>
               <Nav steps={steps} currStageIdx={currStageIdx} />
               <button onClick={closeModal}>✖</button>
            </header>
            <main>
               <h1>*Having issues? Contact us here: <a href="mailto:support@youngstartup.com?subject=Registration Query">support@youngstartup.com</a>.</h1>
               {currStageIdx === 0 && <Select />}
               {currStageIdx === 1 && <Assign />}
               {currStageIdx === 2 && <Payment />}
               {currStageIdx === 3 && <Confirmation />}
            </main>
            <aside>
               {currStageIdx !== 3 && <Summary />}
            </aside>
            <footer>
               {currStageIdx > 0 && !orderResponse.success && <button className='prev' onClick={() => handelClick(-1)}>⊲ prev</button>}
               {invalidInputMsg?.length > 0 && <h1>Invalid Fields</h1>}
               {currStageIdx < 2 && <button className='next' onClick={() => handelClick(1)}>next ⊳</button>}
            </footer>
         </div>
      </div>
   )
}
